/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lyn1': {
    width: 44,
    height: 29,
    viewBox: '0 0 44 29',
    data: '<path pid="0" d="M6.036 13.256L44 0l-3.293 8.685-7.383 2.692-2.145 5.535L0 29z" _fill="#3062A9" fill-rule="nonzero"/>'
  }
})
